import { useState, useEffect } from 'react';
import EventServiceCheckbox from "./EventServiceCheckbox";

const EventServiceMultiSelect = ({ eventServices, onChange }) => {

    const [selectedEventServices, setSelectedEventServices] = useState({});

    const handleCheckboxChange = (eventServiceValue, isChecked) => {
        setSelectedEventServices(prevState => {
            return { ...prevState, [eventServiceValue]: isChecked, }
        });
    };

    useEffect(() => {
        var selected = {};
        eventServices.forEach(element => {
            selected[element.value] = element.active;
        });
        setSelectedEventServices(selected);
    }, [eventServices]);

    useEffect(() => {
        if (onChange) {
            onChange(selectedEventServices);
        }
    }, [selectedEventServices]);

    return (
        <div className='col-12 mt-4 d-flex flex-column'>
            <label htmlFor="event-service" className="form-control-label"><span className="">Services *</span></label>
            <div className='event-form-service-container d-flex flex-row gap-3'>
            {eventServices.map((eventService, index) => (
                <EventServiceCheckbox
                    key={index}
                    eventService={eventService}
                    onChange={handleCheckboxChange}
                />
            ))}
            </div>
        </div>
    );
};

export default EventServiceMultiSelect;